import { useState, useEffect } from "react";
import "./scss/FormFieldCheckbox.scss";
function FormFieldCheckbox({data, value, sending, elementErrors, onChange}) {
	const [err, setErr] = useState(false);
	const [modal, setModal] = useState(false);
	if(value===undefined) value=false;
	const required = data.required;

	console.log('~FormFieldCheckbox', data)
	function setData(e){
		setErr(false);
		let targetValue = e.target.checked;
		console.log('* FormFieldCheckbox sends:', data.id, targetValue)
		onChange(data.id, targetValue);
	}
	const getInputStyling = () => {
		let className = "FormFieldCheckbox md__input mtop--15";
		if(err)	className += ' input--error';
		return className;
	}
	useEffect(() => {
		elementErrors?.errors?.forEach(function(e){
			setErr(true);
		});
	}, [elementErrors])

	return (
		<div className={getInputStyling()} style={{ display: "flex" }}>
			<div style={{ width: 20, height: 20 }}>
				<input onChange={setData} checked={value} disabled={sending} placeholder={data.placeholder} type="checkbox" />
			</div>
			&nbsp;
			<b className="text--danger inline--block" style={{ padding: "0px 2px" }}>
				{ required ? '*'  : '' }
			</b>
			
			<div>
				{data.label && <span onClick={()=>{if(data.showModal) setModal(true)}} dangerouslySetInnerHTML={{__html: data.label}} className="label-content"></span>}
				<div onClick={()=>{if(data.showModal) setModal(true)}} dangerouslySetInnerHTML={{__html: data?.html}}></div>
			</div>
			{elementErrors?.errors.map((error)=> <div className="text--danger">{error.message}</div>)}

			{modal && <div className="modal-overlay active" onClick={() => { setModal(false) }}>
				<div className="modal active animate__animated animate__fadeIn">
					<div className="modal-content" onClick={(e) => { e.stopPropagation(); }}>
						<div className="modal__header">
							<div className="modal__header-title"></div>
							<div className="close-modal modal--x" onClick={() => { setModal(false) }}>
								<svg viewBox="0 0 20 20">
									<path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
								</svg>
							</div>
						</div>
						<div className="modal__body">
							<p dangerouslySetInnerHTML={{__html: data.modalContent}}></p>
						</div>
					</div>
				</div>
			</div>}
		</div>
	);
};
export default FormFieldCheckbox;
